import React, { FC } from 'react';

import { useRequestSignature } from './request-file-signature-modal-hooks';
import {
  Box,
  Checkbox,
  Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography,
  Alert } from '@mui/material';
import { ContainedButton } from 'components/ContainedButton';
import { Controller, useWatch } from 'react-hook-form';

import { useStyles } from './styles';

type RequestDocumentsModalProps = {
  open: boolean;
  documentId: string,
  fileSource: string,
  documentName: string,
  handleClose: () => void;
};

export const RequestFileSignatureModal: FC<RequestDocumentsModalProps> = ({
  open,
  documentId,
  fileSource,
  documentName,
  handleClose,
}) => {
  const {
    t,
    isRequestSignatureLoading,
    control,
    onSendRequest,
    errors,
    isFormValid
  } = useRequestSignature({
    documentId,
    fileSource,
    onClose: handleClose,
  });

  const form = useWatch({ control });

  const classes = useStyles();
  return (
    <Dialog open={open} fullWidth onClose={handleClose}>
      <DialogTitle style={{ padding: "0px" }}>
        <Typography variant="h5" className={classes.title}>{t("ron:confirm-signature-request")}</Typography>
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <Box className={classes.container} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          {errors !== null &&
            <Alert severity="error" classes={{ icon: classes.errorIconContainer }}>
              <Typography variant="subtitle1">{errors}</Typography>
            </Alert>}

          <Box style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
            <Typography variant="body1">{documentName}</Typography>
            <Box style={{ display: "flex", gap: "1rem" }}>
              <Controller
                control={control}
                name="embedded"
                render={({ field: { value, ...field } }) => (
                  <FormControlLabel
                    control={<Checkbox style={{ padding: 0 }} checked={value} {...field} />}
                    label={
                      <Typography variant="caption" color="primary">
                        {t('ron:document-for-ron')}
                      </Typography>
                    }
                    style={{ marginLeft: 0, whiteSpace: 'nowrap' }}
                  />
                )}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions className={classes.actionButtons}>
        <ContainedButton
          text={t('common:close')}
          onClick={handleClose}
        />
        <ContainedButton
          text={t('documents:sendRequest')}
          onClick={onSendRequest}
          isLoading={isRequestSignatureLoading}
          disabled={!isFormValid}
        />
      </DialogActions>
    </Dialog>
  );
};
